module.exports = __webpack_public_path__ + "static/media/provozovna (4).7f5bde3f.png";